import InfoIcon from '@material-ui/icons/Info';

import DiagnosticCreate from './create';
import DiagnosticList from './list';
import DiagnosticShow from './show';
import DiagnosticEdit from './edit';

export default {
    create: DiagnosticCreate,
    list: DiagnosticList,
    show: DiagnosticShow,
    edit: DiagnosticEdit,
    icon: InfoIcon
};